import api from './api'

export const purchaseService = {
  getAll: (params?: { status?: string; supplier?: string; page?: number; limit?: number }) =>
    api.get('/purchases', { params }),

  getById: (id: number | string) =>
    api.get(`/purchases/${id}`),

  create: (data: any) =>
    api.post('/purchases', data),

  receive: (id: number | string, data: any) =>
    api.post(`/purchases/${id}/receive`, data),

  update: (id: number | string, data: any) =>
    api.put(`/purchases/${id}`, data),

  delete: (id: number | string) =>
    api.delete(`/purchases/${id}`),

  // Calculate selling prices based on margin
  calculatePrices: (id: number | string, data: { margin_percent: number; margin_type?: 'retail' | 'wholesale' }) =>
    api.post(`/purchases/${id}/calculate-prices`, data),

  // Update selling prices for purchase items
  updatePrices: (id: number | string, data: { items: any[] }) =>
    api.post(`/purchases/${id}/update-prices`, data),

  // Get product purchase history from a supplier
  getProductHistory: (supplierId: number | string, productId: number | string) =>
    api.get(`/purchases/supplier/${supplierId}/product/${productId}/history`),
}
